
















































































































































import Vue from "vue";
import { computed } from "@vue/composition-api";
import GaIcon from "./GaIcon.vue";
import { SIZE, TYPE, useGenAiPalette } from "../data/design";

/**
 * Card shell for the Gen AI Governance dashboard.
 *
 * Owned by this source so the shared DashboardCard stays untouched — this
 * dashboard follows its own approved reference design, which is lighter and
 * cooler than the rest of the app.
 */
export default Vue.extend({
  components: { GaIcon },
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, default: "" },
    desc: { type: String, default: "" },
    actions: { type: Array, default: () => [] },
    configure_cta_text: { type: String, default: "" },
    /** label rendered above the footer slot; empty hides it */
    footer_title: { type: String, default: "" },
    /** the headline number beside the title; null/"" hides it */
    total: { type: [Number, String], default: null },
    /**
     * A substring of `title` set heavier, e.g. "Employees' Activities" in
     * "Risky Employees' Activities". Ignored if it does not occur in the title,
     * so a stale value degrades to a plain title rather than a broken one.
     */
    title_bold: { type: String, default: "" },
    /** holds the expand/config buttons inert, e.g. while the data loads —
     *  they stay in place so the header does not jump when it arrives */
    actions_disabled: { type: Boolean, default: false },
  },
  setup(props) {
    const has_total = computed(
      () => props.total !== null && props.total !== undefined && props.total !== ""
    );
    const total_display = computed(() =>
      typeof props.total === "number" ? props.total.toLocaleString() : props.total
    );
    const title_parts = computed(() => {
      const title = String(props.title || "");
      const bold = String(props.title_bold || "");
      const at = bold ? title.indexOf(bold) : -1;
      if (at < 0) return { before: title, bold: "", after: "" };
      return {
        before: title.slice(0, at),
        bold,
        after: title.slice(at + bold.length),
      };
    });
    return {
      T: useGenAiPalette(),
      TY: TYPE,
      S: SIZE,
      has_total,
      total_display,
      title_parts,
    };
  },
});
